module.exports = __webpack_public_path__ + "img/L-500.9c098c55.png";